import { useCallback, useEffect, useMemo, useState } from "react";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function useForm_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else useForm_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const useForm = (allValues, fieldValidators)=>{
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});
    const [isInitialValidationDone, setIsInitialValidationDone] = useState(false);
    useEffect(()=>{
        const validateForm = ()=>_async_to_generator(function*() {
                const initialErrors = {};
                for (const [fieldName, validators] of Object.entries(fieldValidators))for (const validate of validators){
                    const result = validate(allValues[fieldName], allValues);
                    const error = result instanceof Promise ? yield result : result;
                    if (error) {
                        initialErrors[fieldName] = error;
                        break;
                    }
                }
                setErrors(initialErrors);
            })();
        if (!isInitialValidationDone) {
            validateForm();
            setIsInitialValidationDone(true);
        }
    }, [
        allValues,
        fieldValidators,
        errors,
        setErrors,
        isInitialValidationDone
    ]);
    const validateField = useCallback((fieldName, value)=>_async_to_generator(function*() {
            const validators = fieldValidators[fieldName] || [];
            for (const validate of validators){
                const result = validate(value, allValues);
                const error = result instanceof Promise ? yield result : result;
                if (error) {
                    setErrors(_object_spread_props(_object_spread({}, errors), {
                        [fieldName]: error
                    }));
                    return error;
                }
            }
            setErrors(_object_spread_props(_object_spread({}, errors), {
                [fieldName]: ''
            }));
        })(), [
        allValues,
        fieldValidators,
        errors
    ]);
    const hasValidationErrors = useMemo(()=>!isInitialValidationDone || Object.values(errors).some((error)=>!!error), [
        isInitialValidationDone,
        errors
    ]);
    const showError = (fieldName)=>{
        setTouched(_object_spread_props(_object_spread({}, touched), {
            [fieldName]: true
        }));
    };
    const handleBlur = (fieldName)=>()=>_async_to_generator(function*() {
                const error = yield validateField(fieldName, allValues[fieldName]);
                setErrors(_object_spread_props(_object_spread({}, errors), {
                    [fieldName]: error || null
                }));
                showError(fieldName);
            })();
    return {
        errors,
        touched,
        validateField,
        hasValidationErrors,
        showError,
        handleBlur
    };
};
export { useForm };
